import { statinModerateIntensityActivity } from './definitions/activities/statinModerateIntensity';
import { ckdOngoingMeasurements } from './definitions/ckdOngoingMeasurements';
import { ckdStageMonitoring } from './definitions/ckdStageMonitoring';
import { masldOngoingMeasurements } from './definitions/masldOngoingMeasurements';
import { obesityOngoingMeasurements } from './definitions/obesityOngoingMeasurements';
import { asthmaOngoingMeasurements, copdOngoingMeasurements } from './definitions/respiratoryOngoingMeasurements';
import {
  hyperthyroidismOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
} from './definitions/thyroidOngoingMeasurements';
import { t2dmOngoingMeasurements } from './definitions/t2dmOngoingMeasurements';
import { t2dmRoutineMonitoring } from './definitions/t2dmRoutineMonitoring';
import { insulinsValueSet, statinsValueSet, sulfonylureasValueSet } from './valueSets/rxNormDrugClasses';

/** The clinical protocols `@liza/medplum-config` deploys. */
export const planDefinitions = {
  t2dmRoutineMonitoring,
  t2dmOngoingMeasurements,
  ckdOngoingMeasurements,
  obesityOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
  hyperthyroidismOngoingMeasurements,
  copdOngoingMeasurements,
  asthmaOngoingMeasurements,
  masldOngoingMeasurements,
  ckdStageMonitoring,
};

/** What the protocols' suggestion actions propose, referenced by `definitionCanonical` and deployed alongside them. */
export const protocolActivityDefinitions = {
  statinModerateIntensityActivity,
};

/** The terminology the protocols reference, deployed alongside them. */
export const protocolValueSets = {
  insulinsValueSet,
  statinsValueSet,
  sulfonylureasValueSet,
};
